import React from 'react';
import Maps from "../../redux/Maps";
import {connect} from "react-redux";
import Utils from "../../utils/Utils";

class LoginRedirect extends React.Component {
    submitForm = () =>  {
        this.props.submitForm();
    }

    gotoResetPassword = () =>  {
        this.props.changeLoginType("retrievePassword");
    }

    gotoRegister = () =>  {
        this.props.changeLoginType("register");
    }

    gotoLogin = () =>  {
        this.props.changeLoginType("mobilePasswordLogin");
    }

    gotoPasswordLogin = () => {
        this.props.changeLoginType("mobilePasswordLogin")
    }

    gotoMobileCodeLogin = () => {
        this.props.changeLoginType('mobileCodeLogin')
    }

    render() {
        let buttons = [];
        if (this.props.agreement) {
            buttons.push(<span key="login-agreement">
                <input type="checkbox" id="login-agreement" name="login-agreement"
                       value="1" checked={this.props.agreement.checked}
                       onChange={this.props.agreement.onChange}/>
                <label htmlFor="login-agreement">我已阅读并同意
                    <a href={process.env.PUBLIC_URL + "/agreement.html"}
                       className="agreement"
                       target="_blank" rel="noopener noreferrer">《用户协议》</a>
                </label>
            </span>)
        }
        const loginConfig = Utils.cacheLoginConfig()
        if(this.props.passwordLogin){
            buttons.push(<button key="password-login" type="button" onClick={this.gotoPasswordLogin} className="password-login">密码登录</button>)
        }
        if(this.props.mobileCodeLogin && loginConfig.mobile_captcha_login === '1'){
            buttons.push(<button key="mobile-code-login" type="button" onClick={this.gotoMobileCodeLogin} className="mobile-code-login">验证码登录</button>)
        }
        if (this.props.resetPassword && window.configs.cjy_flag) {
            buttons.push(<button key="reset-password" type="button" onClick={this.gotoResetPassword} className="reset-password">忘记密码</button>)
        }
        if (this.props.register) {
            buttons.push(<button key="register" type="button" onClick={this.gotoRegister} className="register">快速注册</button>)
        }
        if (this.props.registerToLogin) {
            buttons.push(<span key="login">已有账号，<button type="button" onClick={this.gotoLogin} className="register-to-login">立即登录</button></span>)
        }
        if (this.props.resetToLogin) {
            buttons.push(<span key="login"><button type="button" onClick={this.gotoLogin} className="login">立即登录</button></span>)
        }
        return (
            <div className="login-redirect">
                {buttons}
            </div>
        );
    }
}

export default connect(null, Maps.mapLoginTypeDispatchToProps)(LoginRedirect);
